import {
  io,
  type ManagerOptions,
  type Socket,
  type SocketOptions,
} from 'socket.io-client';

// oxlint-disable-next-line no-explicit-any -- Required by socket.io-client's EventsMap type constraint
type SocketServerToClient = Record<string, (...args: any[]) => void>;

// oxlint-disable-next-line no-explicit-any -- Required by socket.io-client's EventsMap type constraint
type SocketClientToServer = Record<string, (...args: any[]) => void>;

export const getSocketClient = <
  TServerToClient extends SocketServerToClient = SocketServerToClient,
  TClientToServer extends SocketClientToServer = SocketClientToServer,
>(
  endpoint?: string,
  options?: Partial<ManagerOptions & SocketOptions>
): Socket<TServerToClient, TClientToServer> => {
  return io(endpoint, options);
};
